module.exports = __webpack_public_path__ + "static/stava_img_2-65d07ced5152ef6c70a895e9a483b2a2.png";